import { asText } from "@prismicio/client"
import { SliceZone } from "@prismicio/react"
import classNames from "classnames"
import React from "react"

import { RichText } from "@/components/Generic/RichText/RichText/RichText"
import type { FormattedLegal } from "@/libs/prismic/types"
import { components } from "@/slices"

export type ContentProps = {
  legalPage: FormattedLegal
  className?: string
  embed?: boolean
}

export const Content = ({ legalPage, embed, className }: ContentProps) => {
  const { title, content } = legalPage

  return (
    <div
      className={classNames(
        "w-full",
        embed ? "max-w-screen-md" : "mx-auto max-w-screen-xl px-6 pt-12 pb-section md:pt-16 xl:pt-20",
        className,
      )}>
      <h1 className={classNames("mb-6 text-black", embed ? "title6" : "title4 md:title3")}>{asText(title)}</h1>
      <RichText field={content} />
      <SliceZone slices={legalPage.slices} components={components} />
    </div>
  )
}
